import { useI18n } from "@core/i18n/i18n";
import { PatientStatus } from "@domain/patient/patient";
import { sendAnalyticsEventReinvitePatient } from "@domain/patient/patient-analytics";
import { AnalyticsProgramClickType, sendAnalyticsEventViewPatientDetail } from "@domain/program/program-analytics";
import styled from "@emotion/styled";
import { DialogContext, ModalId } from "@ui/components/dialog/dialog-provider";
import { ExpirationRemainingDays } from "@ui/pages/home/components/expiration-remaining-days";
import { PatientActionButton } from "@ui/pages/home/components/patient-action-button";
import { ExtendedPendingPatient } from "@ui/pages/home/components/pending-patient-listing";
import { ResendCodeButton } from "@ui/pages/home/components/resend-code-button";
import { DialogStep } from "@ui/pages/home/pending-patient-dialog/add-patient-dialog";
import { row, stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import React, { useContext } from "react";

interface PendingPatientListingRowMobileProps {
	patient: ExtendedPendingPatient;
}

export const PendingPatientListingRowMobile: React.FC<PendingPatientListingRowMobileProps> = ({ patient }) => {
	const { format, formatDateMed } = useI18n();
	const dialogContext = useContext(DialogContext);

	return (
		<FlexContainer
			onClick={() => {
				sendAnalyticsEventViewPatientDetail(patient.analyticsId, AnalyticsProgramClickType.LIST_CLICK);
				dialogContext?.openModal(ModalId.AddPatient, {
					pendingPatient: patient,
					step: DialogStep.RegistrationDetails,
				});
			}}
		>
			<Content>
				<KebabContainer>
					<PatientActionButton patient={{ ...patient, status: PatientStatus.Pending }} />
				</KebabContainer>
				<PatientInformation>
					<PatientName className="p-size-s-bold">{patient.name}</PatientName>
					<Row>
						<div>{format("home.pendingPatientsListing.codeRowMobile")}</div>
						<div className="p-size-s-bold">{patient.activationCode}</div>
					</Row>
					<Row>
						<div>{format("home.pendingPatientsListing.creationDateRowMobile")}</div>
						<div className="p-size-s-bold">{formatDateMed(patient.creationDate)}</div>
					</Row>
					<Row>
						<div>{format("home.pendingPatientsListing.expiresInRowMobile")}</div>
						<div className="p-size-s-bold">
							<ExpirationRemainingDays patient={patient} />
						</div>
					</Row>
					<ResendCodeButton
						onClick={() => {
							sendAnalyticsEventReinvitePatient();
							dialogContext?.openModal(ModalId.AddPatient, { pendingPatient: patient });
						}}
					/>
				</PatientInformation>
			</Content>
		</FlexContainer>
	);
};

const FlexContainer = styled.div`
	${row(undefined, "spacebetween", "center")};
	padding: 24px 32px 24px 24px;
	border-bottom: 1px solid ${colors.grey25};
	cursor: pointer;
	position: relative;
`;

const Content = styled.div`
	width: 100%;
`;

const PatientInformation = styled.div`
	${stack(8, "center", "flexstart")};
	overflow: hidden;
`;
const PatientName = styled.p`
	align-self: stretch;
	overflow: hidden;
	text-overflow: ellipsis;
	margin-bottom: 10px;
`;

const Row = styled.div`
	${row(8)}
`;

const KebabContainer = styled.div`
	position: absolute;
	top: 8px;
	right: 8px;
`;
